import { render } from "./AdviserRoomAssignDataTable.vue?vue&type=template&id=3f871386&scoped=true"
import script from "./AdviserRoomAssignDataTable.vue?vue&type=script&lang=js"
export * from "./AdviserRoomAssignDataTable.vue?vue&type=script&lang=js"

import "./AdviserRoomAssignDataTable.vue?vue&type=style&index=0&id=3f871386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f871386"]])

export default __exports__